// Country → customer-facing invoice currency (mirror of backend
// _resolve_invoice_currency in server.py — keep in sync).
const COUNTRY_CURRENCY = {
  CA: 'CAD',
  GB: 'GBP', UK: 'GBP',
  DK: 'DKK', SE: 'SEK', NO: 'NOK',
  AT: 'EUR', BE: 'EUR', HR: 'EUR', CY: 'EUR', EE: 'EUR', FI: 'EUR', FR: 'EUR',
  DE: 'EUR', GR: 'EUR', IE: 'EUR', IT: 'EUR', LV: 'EUR', LT: 'EUR', LU: 'EUR',
  MT: 'EUR', NL: 'EUR', PT: 'EUR', SK: 'EUR', SI: 'EUR', ES: 'EUR',
};

export const detectInvoiceCurrency = (country) =>
  COUNTRY_CURRENCY[(country || '').trim().toUpperCase()] || 'USD';
